import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import axios from "axios";
import { formatMoneda, cmbCedula } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { RegistrarPago } from "./modalRegistrarPago";

const RegistrarPagoNotadeDebito = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const anioActu = JSON.parse(sessionStorage.getItem("anioactu"));
  const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const accbtncntxcobrar = JSON.parse(
    sessionStorage.getItem("accbtncntxcobrarc")
  );

  const txtIdNotaEntrega = useRef();
  const txtFecha = useRef();
  const txtConcepto = useRef();
  const txtMontoTotal = useRef();
  const txtAbono = useRef();
  const txtSaldo = useRef();
  const btnCancela = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const cmbMoneda = useRef();
  const txtFechaVencimiento = useRef();
  const [actcredit, setActcredit] = useState(0);
  const [actanticipo, setActanticipo] = useState(0);
  const [operacion, setOperacion] = useState(0);
  const [mostrar1, setMostrar1] = useState(false);
  const [numNota, setNumNota] = useState("");
  const [idfact, setIdfact] = useState(0);
  const [cedRif, setCedRif] = useState("");
  const [nomVendedor, setNomVendedor] = useState("");
  const [idCliente, setIdCliente] = useState(null);
  const [nomCliente, setNomCliente] = useState("");
  const [dirCliente, setDirCliente] = useState("");
  const [visible, setVisible] = useState(0);
  const [monto, setMonto] = useState(0.0);
  const [desde, setDesde] = useState(0);
  const [esretencion, setEsretencion] = useState(0);
  const [combomoneda, setComboMoneda] = useState([]);
  const [numfact, setNumfact] = useState("");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "2",
    descripcion: "DOLARES",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 0.0,
  });
  const [activate, setActivate] = useState(false);

  const blanquear = () => {
    setMonto(0.0);
    setActivate(false);
    setOperacion(0);
    setMostrar1(false);
    setVisible(0);
    cmbMoneda.current.selectedIndex = -1;
    setMoneda({
      idmoneda: "1",
      descripcion: "BOLIVARES",
      simbolo: "Bs",
      predeterminada: false,
      valormoneda: 1.0,
    });
    txtIdNotaEntrega.current.value = "";
    txtFechaVencimiento.current.value = "";
    txtIdNotaEntrega.current.setAttribute("disabled", true);
    cmbRif.current.selectedIndex = -1;
    txtRif.current.value = "";
    setNumNota("");
    setNomCliente("");
    setDirCliente("");
    setNomVendedor("");
    setCedRif("");
    txtFecha.current.value = "";
    txtMontoTotal.current.value = "0,00";
    txtConcepto.current.value = "";
    setActcredit(0);
    setActanticipo(0);
    setDesde(0);
  };

  const seleccionarCliente = (rif, tecla) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let nomid2 = "cliente";
    let id = rif;
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            if (response.data.agenteretencion === true) {
              setEsretencion(1);
            } else {
              setEsretencion(0);
            }
            cmbRif.current.value = response.data.rif.trim().substring(0, 1);
            txtRif.current.value = response.data.rif.trim().substring(1, 10);
            setIdCliente(response.data.idagente);
            setNomCliente(response.data.nombre);
            setDirCliente(response.data.direccion.trim());
            if (tecla === 13) {
              txtFecha.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un cliente con este codigo",
              icono: "informacion",
            });
            txtRif.current.value = "";
            cmbRif.current.selectedIndex = -1;
            if (tecla === 13) {
              txtRif.current.focus();
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarVendedor = (idv) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let nomid2 = "vendedor";
    let id = idv === null ? "0" : idv;
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setCedRif(response.data.rif);
            setNomVendedor(response.data.nombre);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El usuario no tiene un vendedor asociado",
              icono: "informacion",
            });
            blanquear();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarMoneda = (id) => {
    let campos = "*";
    let nomtab = "moneda";
    let nomid = "idmoneda";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setMoneda(response.data);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistro = (id) => {
    let campos = "*";
    let nomtab = "notaentrega";
    let nomid = "idnotaentrega";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtIdNotaEntrega.current.value = response.data.idnotaentrega;
            setIdfact(response.data.idnotaentrega);
            setNumfact(response.data.numnotaentrega);

            txtIdNotaEntrega.current.setAttribute("disabled", true);
            setVisible(0);

            txtFecha.current.value = moment(response.data.fecha).format(
              "YYYY-MM-DD"
            );
            txtFechaVencimiento.current.value = moment(
              response.data.fechavencimiento
            ).format("YYYY-MM-DD");
            setNumNota(response.data.numnotaentrega);
            cmbMoneda.current.value = response.data.idmoneda;
            txtConcepto.current.value = response.data.descripcion;
            txtMontoTotal.current.value = formatMoneda(
              response.data.totalmonto
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );

            let tosaldo = 0.0;
            tosaldo = response.data.totalmonto - props.abono;

            txtAbono.current.value = formatMoneda(
              props.abono.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
            txtSaldo.current.value = formatMoneda(
              tosaldo.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );

            setMonto(tosaldo);
            seleccionarCliente(response.data.idcliente, 46);
            seleccionarVendedor(response.data.idvendedor);
            seleccionarMoneda(response.data.idmoneda);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "ID no existe.",
              icono: "informacion",
            });
            txtIdNotaEntrega.current.value = "";
            txtIdNotaEntrega.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarMonedas = () => {
    let campos =
      "idmoneda, trim(descripcion) as descripcion, simbolo, predeterminada, valormoneda, subpredeterminada";
    let nomtab = "moneda";
    let orden = "idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setComboMoneda(response.data);
            seleccionarMoneda(response.data[0].idmoneda);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
                setMonedaSub(response.data[i]);
              }
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChangeValidar = () => {
    if (
      accbtncntxcobrar &&
      accbtncntxcobrar.toString().substring(1, 2) === "1"
    ) {
      seleccionarCredito(idCliente);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const imprimirNotaDebito = () => {
    if (
      accbtncntxcobrar &&
      accbtncntxcobrar.toString().substring(4, 5) === "1"
    ) {
      let debt = 0;
      if (txtIdNotaEntrega.current.value !== "") {
        let idnot = txtIdNotaEntrega.current.value;

        var reporte = "ReportNotaDebito";

        window.open(
          op.reportes +
          "/ventas?afiliado=" +
          afiliado +
          "&reporte=" +
          reporte +
          "&idnota=" +
          idnot,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione la nota de Debito !",
          icono: "informacion",
        });
        debt = 1;
      }

      if (debt === 1) {
        txtIdNotaEntrega.current.focus();
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const seleccionarCredito = (id) => {
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/seleccionarcredito?idcliente=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let montototal = 0.0;

            for (let i = 0; i < response.data.length; i++) {
              montototal =
                parseFloat(montototal) +
                parseFloat(response.data[i].totalmonto);
            }

            if (montototal > 0 && props.anticipo > 0) {
              setMostrar1(true);
              setActcredit(1);
              setActanticipo(1);
            } else {
              if (props.anticipo > 0) {
                setMostrar1(true);
                setActcredit(0);
                setActanticipo(1);
              } else if (montototal > 0) {
                setMostrar1(true);
                setActcredit(1);
                setActanticipo(0);
              } else {
                setMostrar1(true);
                setActcredit(0);
                setActanticipo(0);
              }
            }
            setActivate(false);
          } else {
            if (props.anticipo > 0) {
              setMostrar1(true);
              setActcredit(0);
              setActanticipo(1);
            } else {
              setMostrar1(true);
              setActcredit(0);
              setActanticipo(0);
            }
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const renderizar = () => {
    props.onRenderizar();
    props.onHideCancelar();
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="xl"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.ope === 1) {
          seleccionarMonedas();
          seleccionarRegistro(props.idnot);
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Nota de Debito</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row col-md-12 " style={{ margin: 0 }}>
          <div className="col-md-12 row border-azul mx-auto justify-content-between rounded py-1">
            <div
              className="col-md-12 row mx-auto d-flex justify-content-between mb-1"
              style={{ fontSizeAdjust: "0.6" }}
            >
              <div className="colfull col220 mb-1">
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    CODIGO:
                  </label>
                  <input
                    type="text"
                    disabled
                    ref={txtIdNotaEntrega}
                    name="idnotaentre"
                    className="form-control form-control-lg"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </div>

              <div className="colfull col400 mb-1">
                <label className="text-left">
                  NOTA DE DEBITO N°:{" "}
                  <span className="col fw-bold text-danger">
                    &nbsp;{numNota}
                  </span>
                </label>
              </div>
            </div>

            <div
              className="col-md-12 row mx-auto d-flex justify-content-between mb-1"
              style={{ fontSizeAdjust: "0.6" }}
            >
              <div className="colfull col-pd-300 mb-3">
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    TIPO MONEDA:
                  </label>
                  <select
                    className="form-control form-control-sm fs-6 text-center fw-bold"
                    disabled
                    ref={cmbMoneda}
                  >
                    {combomoneda &&
                      combomoneda.map((item, index) => (
                        <option key={index} value={item.idmoneda}>
                          {" "}
                          {`${item.descripcion} ${item.simbolo} ${formatMoneda(
                            item.valormoneda
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )}`}{" "}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-pd-210 ml-auto">
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    FECHA:
                  </label>
                  <input
                    autoComplete="off"
                    type="date"
                    disabled
                    ref={txtFecha}
                    className="form-control text-uppercase fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    name="fecha"
                  />
                </div>
              </div>
              <div className="col-pd-330 ml-auto">
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    FECHA DE VENCIMIENTO:
                  </label>
                  <input
                    autoComplete="off"
                    disabled
                    type="date"
                    ref={txtFechaVencimiento}
                    className="form-control text-uppercase fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    name="fechav"
                  />
                </div>
              </div>
            </div>

            <div
              className="colfull1070 colfull60p mx-auto mb-1 py-1"
              style={{ fontSizeAdjust: "0.6" }}
            >
              <div className="col-md-12 mx-auto row border-azul rounded py-2">
                <span className="fw-bold mb-1">Datos del Cliente</span>
                <div className="input-group input-group-sm mb-1 col-pd-260 px-2">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    CEDULA/RIF:{" "}
                  </label>
                  <select
                    ref={cmbRif}
                    name="cmbrif"
                    disabled
                    className="form-select form-select-sm col-md-3 text-center "
                    aria-label=".form-select-sm example"
                  >
                    <option value="">--</option>
                    {cmbCedula.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.value}
                      </option>
                    ))}
                  </select>
                  <input
                    ref={txtRif}
                    autoComplete="off"
                    disabled
                    maxLength={9}
                    type="text"
                    className="form-control fs-6"
                    name="cedula"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
                <div className="input-group input-group-sm mb-1 col-pd-340 px-0">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    NOMBRE:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    className="form-control fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={nomCliente}
                  />
                </div>
                <div className="input-group input-group-sm col-md-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    DIRECCION:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    className="form-control fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={dirCliente}
                  />
                </div>
              </div>
            </div>

            <div
              className="colfull1070 colfull40p mx-auto mb-1 row py-1"
              style={{ fontSizeAdjust: "0.6" }}
            >
              <div className="col-md-12 mx-auto row border-azul rounded py-2">
                <span className="fw-bold mb-1">Datos del Vendedor</span>
                <div className="input-group input-group-sm col-pd-220 px-2">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-sm"
                    style={{ height: "85%" }}
                  >
                    CEDULA/RIF:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    className="form-control fs-6"
                    style={{ height: "85%" }}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={cedRif}
                  />
                </div>
                <div className="input-group input-group-sm col-md-12">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-sm"
                    style={{ height: "85%" }}
                  >
                    NOMBRE:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    style={{ height: "85%" }}
                    className="form-control fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={nomVendedor}
                  />
                </div>
              </div>
              <div className="col-md-6"></div>
            </div>
            <div className="col-12 row m-0">
              <div
                className="col-md-12 border-azul rounded p-2 shadow"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="input-group input-group-sm mb-2 col-md-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    CONCEPTO:
                  </label>
                  <textarea
                    className="form-control uppercase fs-6"
                    ref={txtConcepto}
                    disabled
                    aria-label="With textarea"
                    style={{ minHeight: 50 }}
                    defaultValue={""}
                  />
                </div>
                <div
                  className="col-4 ml-auto m-0 border-azul rounded"
                  style={{ backgroundColor: "#dbeeff" }}
                >
                  <div className="col-12 mb-2"></div>
                  <div className="input-group input-group-sm mb-2 ml-auto">
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                    >
                      MONTO TOTAL {moneda.simbolo}:
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      ref={txtMontoTotal}
                      disabled
                      className="form-control text-end fs-6 bg-transparent border-0"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue="0,00"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 ml-auto">
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                    >
                      ABONO {moneda.simbolo}:
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      ref={txtAbono}
                      disabled
                      className="form-control text-end fs-6 bg-transparent border-0"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue="0,00"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 ml-auto">
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                    >
                      SALDO {moneda.simbolo}:
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      ref={txtSaldo}
                      disabled
                      className="form-control text-end fs-6 bg-transparent border-0"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue="0,00"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          onClick={onChangeValidar}
          style={{ margin: "5px" }}
        >
          <i className="fas fa-check-circle"> Registrar Pago</i>{" "}
        </button>
        <button
          onClick={imprimirNotaDebito}
          style={{ margin: "5px" }}
          className="btn btn-sm btn-primary rounded-pill"
          title="Imprimir Nota de Entrega"
        >
          <i className="fa fa-print"> Imprimir</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <RegistrarPago
        show={mostrar1}
        tipo={"debito"}
        abonos={props.abono}
        esretenedor={esretencion}
        anticipo={props.anticipo}
        idvendedor={idVendedor}
        idfactu={idfact}
        numfactu={numfact}
        siescredit={actcredit}
        siesanticipo={actanticipo}
        ope={1}
        montoiva={"0.00"}
        iva={"0.00"}
        onRenderizar={renderizar}
        idclient={idCliente}
        monto={monto}
        idmoned={moneda.idmoneda}
        onHideCancelar={() => {
          setMostrar1(false);
        }}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>Cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </Modal>
  );
};
export default RegistrarPagoNotadeDebito;



// WEBPACK FOOTER //
// ./src/components/finanzas/registrarPagoNotaDebito.js